var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3752 22.9585L11.6035 32.7302C9.8546 34.479 7.01908 34.479 5.27017 32.7302C3.52127 30.9812 3.52127 28.1457 5.27017 26.3969L15.0418 16.6252M8.72268 29.2918H8.70849M32.2343 21.1483C30.3509 23.0313 26.8073 22.9582 21.3739 22.9582C17.8782 22.9582 15.044 20.1197 15.0422 16.6241C15.0422 11.1943 14.969 7.64869 16.8524 5.76568C18.7356 3.88269 19.5675 3.95892 27.9102 3.95892C28.7164 3.95547 29.1222 4.93049 28.5522 5.50057L24.2567 9.79647C23.1664 10.8869 23.1634 12.6547 24.2538 13.745C25.3443 14.8352 27.1122 14.8353 28.2028 13.7452L32.4995 9.45037C33.0697 8.88043 34.0448 9.28614 34.0414 10.0923C34.0414 18.4336 34.1177 19.2654 32.2343 21.1483Z",
    stroke: "url(#paint0_linear_696_1987)",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_1987",
    x1: 6.50016,
    y1: 7.5,
    x2: 23.0002,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43FF99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.782e0d111f2963c2add16c5343b366ca.svg";
export { ForwardRef as ReactComponent };